import { render, staticRenderFns } from "./MmrList.vue?vue&type=template&id=681cd079&scoped=true"
import script from "./MmrList.vue?vue&type=script&lang=js"
export * from "./MmrList.vue?vue&type=script&lang=js"
import style0 from "./MmrList.vue?vue&type=style&index=0&id=681cd079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cd079",
  null
  
)

export default component.exports